export default __webpack_public_path__ + "static/media/icon2.ad7f2b2d.svg";